import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect(){
    this.validateGraduationDateOnBlur = this.validateGraduationDateOnBlur.bind(this)
    this.graduationDateField?.addEventListener("blur", this.validateGraduationDateOnBlur)
  }

  disconnect(){
    this.graduationDateField?.removeEventListener("blur", this.validateGraduationDateOnBlur)
  }

  showNextDropdown(ev){
    let selectedOption = this.selectedValue(ev.target)
    const specialtyStages = this.specialtyLearningStages(ev)
    if(ev.params.npWorkflow || specialtyStages.includes(selectedOption)){
      this.showSpecialityDropdown()
      this.hideClerkshipRotationCourseDropdown()
      if (ev.params.npWorkflow && !specialtyStages.includes(selectedOption)){
        this.showDateFields()
      }else{
        this.hideDateFields()
      }
    }else{
      this.hideSpecialityDropdown()
      this.showClerkshipRotationCourseDropdown()
      this.showDateFields()
    }
    this.showOtherTextBox(ev)
  }

  specialtyLearningStages(ev){
    return ev.params.specialtyLearningStages || []
  }

  showOtherTextBox(ev){
    let selectedOption = this.selectedValue(ev.target)
    if(["Basic Science","Pre-clerkship/didactic course","Sub-I/Advanced Internship","Elective","Other"].includes(selectedOption)){
      document.getElementById(ev.params.otherTextbox).style.display = 'block'
      document.getElementById(ev.params.otherTextbox).setAttribute("required", "true")
    }else{
      document.getElementById(ev.params.otherTextbox).style.display = 'none'
      document.getElementById(ev.params.otherTextbox).removeAttribute("required", "true")
    }
  }

  // Design-system uses registration_form_*; legacy profile uses user_*
  dateInput(name){
    return document.getElementById(`registration_form_${name}`) || document.getElementById(`user_${name}`)
  }

  showDateFields(){
    const startDate = this.dateInput("start_date")
    const endDate = this.dateInput("end_date")
    const graduationDay = this.dateInput("graduation_day")
    document.getElementById("start-date-div").style.display = 'block';
    document.getElementById("end-date-div").style.display = 'block';
    document.getElementById("graduation-day-div").style.display = 'block';
    document.getElementById("start-date-label")?.classList.add("required");
    document.getElementById("end-date-label")?.classList.add("required");
    document.getElementById("graduation-day-label")?.classList.add("required");
    startDate?.setAttribute("required", "true")
    endDate?.setAttribute("required", "true")
    graduationDay?.setAttribute("required", "true")
    document.getElementById("learning-journey-div").classList.add("learning-journey")
    const divider = document.getElementById("divider")
    if (divider) divider.style.display = 'block'
  }

  hideDateFields(){
    const startDate = this.dateInput("start_date")
    const endDate = this.dateInput("end_date")
    const graduationDay = this.dateInput("graduation_day")
    document.getElementById("start-date-div").style.display = 'none';
    document.getElementById("end-date-div").style.display = 'none';
    document.getElementById("graduation-day-div").style.display = 'none';
    document.getElementById("start-date-label")?.classList.remove("required");
    document.getElementById("end-date-label")?.classList.remove("required");
    document.getElementById("graduation-day-label")?.classList.remove("required");
    startDate?.removeAttribute("required", "true")
    endDate?.removeAttribute("required", "true")
    graduationDay?.removeAttribute("required", "true")
    if (startDate) startDate.value = ""
    if (endDate) endDate.value = ""
    document.getElementById("learning-journey-div").classList.remove("learning-journey")
    const divider = document.getElementById("divider")
    if (divider) divider.style.display = 'none'
  }

  showSpecialityDropdown(){
    document.getElementById("speciality-div").style.display = 'block';
    this.markRequired("registration_form_specialty_main")
  }

  hideSpecialityDropdown() {
    document.getElementById("speciality-div").style.display = 'none';
    this.clearRequired("registration_form_specialty_main")
    this.setDropdownValue("registration_form_specialty_main", "")
    document.getElementById("specialty-other-box").value=""
  }

  showClerkshipRotationCourseDropdown(){
    document.getElementById("clerkship-rotation-course-div").style.display = 'block';
    this.markRequired("registration_form_clerkship_rotation_course_main")
  }

  hideClerkshipRotationCourseDropdown(){
    document.getElementById("clerkship-rotation-course-div").style.display = 'none';
    this.clearRequired("registration_form_clerkship_rotation_course_main")
    this.setDropdownValue("registration_form_clerkship_rotation_course_main", "")
    document.getElementById("clerkship-rotation-course-other-box").value=""
  }

  validateDateFields(event){
    if(document.getElementById("educator-field-div").style.display == 'block') {
      this.validateCheckboxes()
    }
    if (!this.validateRequiredDropdowns(event)) {
      return
    }
    let startDate = this.dateInput("start_date")?.value;
    if (startDate) {
      if (!this.isValidDate(startDate)) {
        alert("Please enter a valid start date in the format MM-DD-YYYY.");
        event.preventDefault();
        return;
      }
    }

    let endDate = this.dateInput("end_date")?.value;
    if (endDate) {
      if (!this.isValidDate(endDate)) {
        alert("Please enter a valid end date in the format MM-DD-YYYY.");
        event.preventDefault();
        return;
      }
    }

    if (startDate && endDate) {
      let start = this.parseProfileDate(startDate);
      let end = this.parseProfileDate(endDate);
    
      if (end <= start) {
        alert("Please select an end date that is after the start date.");
        event.preventDefault();
        return;
      }
    }

    if (!this.validateGraduationDate()) {
      event.preventDefault();
      this.graduationDateField?.reportValidity()
      return;
    }
  }

  validateGraduationDateOnBlur(){
    this.validateGraduationDate()
    this.graduationDateField?.reportValidity()
  }

  validateGraduationDate(){
    let graduationDate = this.graduationDateField;

    if (!graduationDate) {
      return true;
    }

    if (!graduationDate.value) {
      graduationDate.setCustomValidity("")
      return true;
    }

    if (!this.isValidDate(graduationDate.value)) {
      graduationDate.setCustomValidity("Please enter a valid graduation date in the format MM-DD-YYYY.")
      return false;
    }

    graduationDate.setCustomValidity("")
    return true;
  }

  get graduationDateField(){
    return document.getElementById("registration_form_graduation_day")
  }

  isValidDate(dateString) {
    return Boolean(this.parseProfileDate(dateString))
  }

  parseProfileDate(dateString) {
    let regex = /^\d{2}-\d{2}-\d{4}$/;

    if (!regex.test(dateString || "")) {
      return null;
    }

    let parts = dateString.split('-');
    let year = parseInt(parts[2], 10);
    let month = parseInt(parts[0], 10);
    let day = parseInt(parts[1], 10);
    if (year < 2000 || year > 2100) {
      return null;
    }

    let date = new Date(year, month - 1, day);

    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      return null;
    }

    return date;
  }

  showProgramNameDropdown(ev){
    this.showOtherTextBox(ev)
    let selectedOption = this.selectedValue(ev.target)
    let newOptions = []
    if(selectedOption == "MD") {
      newOptions = ev.params.mdPrograms
    }else if(selectedOption == "DO"){
      newOptions = ev.params.doPrograms
    }else if(selectedOption == "PA"){
      newOptions = ev.params.paPrograms
    }else if(selectedOption == "NP/DNP/Nursing") {
      newOptions = ev.params.npPrograms
    }else{
      newOptions = ev.params.allPrograms
    }
    this.replaceDropdownOptions("registration_form_program_name_main", newOptions)
    const programNameOtherBox = document.getElementById("program-name-other-box")
    if (programNameOtherBox) {
      programNameOtherBox.style.display = "none"
      programNameOtherBox.removeAttribute("required")
      programNameOtherBox.value = ""
    }
    document.getElementById("program-name-div").style.display = 'block';
    this.markRequired("registration_form_program_name_main")
    if(ev.params.indSubWorkflow) {
      this.indSubWorkflow(ev)
    }
  }

  toggleOtherTextBox(ev){
    const otherBox = document.getElementById(ev.params.otherTextbox)

    if (!otherBox) {
      return
    }

    if (this.selectedValue(ev.target) === "Other") {
      otherBox.style.display = "block"
    } else {
      otherBox.style.display = "none"
    }
  }

  changedProfileRole(ev){
    this.toggleProfileRoleTitle(this.selectedValue(ev.target))
    if(ev.params.indSubWorkflow) {
      this.indSubWorkflow(ev)
    }
    document.getElementById("profile-role-title-box").value=""
  }

  toggleProfileRoleTitle(selectedRole){
    const titleBox = document.getElementById("profile-role-title-box")

    if (!titleBox) {
      return
    }

    if (selectedRole === "" || selectedRole === "Student") {
      titleBox.style.display = "none"
    } else {
      titleBox.style.display = "block"
    }
  }

  showLearningStageDropdown(){
    document.getElementById("learning-stage-div").style.display = 'block';
    this.markRequired("registration_form_learning_stage_main")
  }

  hideLearningStageDropdown() {
    document.getElementById("learning-stage-div").style.display = 'none';
    this.clearRequired("registration_form_learning_stage_main")
    this.setDropdownValue("registration_form_learning_stage_main", "")
    document.getElementById("learning-stage-other-box").value=""
  }

  showEducatorFields(){
    document.getElementById("educator-field-div").style.display = 'block';
  }

  hideEducatorFields(){
    document.getElementById("educator-field-div").style.display = 'none';
    document.getElementById("work-with-learners-in").
      querySelectorAll('input[type=checkbox]').forEach(function(checkbox) {
        checkbox.checked = false;
      });

    document.getElementById("work-with-students-in").
      querySelectorAll('input[type=checkbox]').forEach(function (checkbox) {
        checkbox.checked = false;
      });

    document.getElementById("primary-clinical-discipline").
      querySelectorAll('input[type=checkbox]').forEach(function (checkbox) {
        checkbox.checked = false;
      });

    document.getElementById("interests").
      querySelectorAll('input[type=checkbox]').forEach(function (checkbox) {
        checkbox.checked = false;
      });

    document.getElementById("educator-field-div").
      querySelectorAll("[data-other-field-toggle-target='input']").forEach(function (input) {
        input.removeAttribute("required");
        input.value = "";
        input.classList.remove("form-input-error");
        input.style.display = "none";
      });
  }

  indSubWorkflow(ev){
    this.hideDateFields()
    this.hideClerkshipRotationCourseDropdown()
    let selectedRoleEl = document.getElementById("registration_form_profile_role")
    let selectedRole = selectedRoleEl && this.selectedValue(selectedRoleEl)
    let selectedProgramType = this.selectedValue(document.getElementById("registration_form_program_type_main"))
    if(selectedRole && selectedProgramType) {
      if (selectedRole == "Student") {
        this.showLearningStageDropdown()
        this.hideSpecialityDropdown()
        this.hideEducatorFields()
        let newOptions = []
        if (["MD", "DO", "Other"].includes(selectedProgramType)) {
          newOptions = ev.params.mdLsOptions
        } else if (selectedProgramType == "PA") {
          newOptions = ev.params.paLsOptions
        } else if (selectedProgramType == "NP/DNP/Nursing") {
          newOptions = ev.params.npLsOptions
        } else {
          this.hideLearningStageDropdown()
          this.showSpecialityDropdown()
        }
        if (newOptions.length > 0) {
          this.replaceDropdownOptions("registration_form_learning_stage_main", newOptions)
        }
      } else if (selectedRole == "Resident/Chief Resident/Fellow") {
        this.hideLearningStageDropdown()
        this.showSpecialityDropdown()
        this.hideEducatorFields()
      } else {
        this.showEducatorFields()
        this.hideLearningStageDropdown()
        this.hideSpecialityDropdown()
      }
    }
  }

  selectedValue(element){
    if (!element) {
      return ""
    }

    if (element.selectedOptions) {
      return element.selectedOptions[0]?.value || ""
    }

    if (element.matches?.("input[type='hidden']")) {
      return element.value
    }

    return element.querySelector?.("input[type='hidden']")?.value || element.value || ""
  }

  setDropdownValue(id, value, dispatch = false){
    const field = document.getElementById(id)

    if (!field) {
      return
    }

    field.value = value
    if (dispatch) {
      field.dispatchEvent(new Event("change", { bubbles: true }))
    }
    this.syncDropdownSummary(field)
  }

  replaceDropdownOptions(id, options){
    const field = document.getElementById(id)

    if (!field) {
      return
    }

    if (field.tagName === "SELECT") {
      field.innerHTML = ""
      options.forEach((optionData) => {
        const option = document.createElement("option")
        option.value = optionData
        option.textContent = optionData
        field.appendChild(option)
      })
      return
    }

    const shell = field.closest("[data-controller~='railsui-dropdown-menu']")
    const menu = shell?.querySelector("[data-railsui-dropdown-menu-target~='menu']")

    if (!menu) {
      field.value = ""
      return
    }

    const menuBody = menu.querySelector("[data-railsui-dropdown-menu-target~='menuBody']") || menu

    menu.querySelectorAll("[data-railsui-dropdown-menu-target~='row']").forEach((row) => row.remove())

    options.forEach((optionData, index) => {
      if (!optionData) {
        return
      }

      const option = document.createElement("button")
      option.type = "button"
      option.id = `${id}_option_${index + 1}_${String(optionData).replace(/[^a-zA-Z0-9:_-]/g, "_")}`
      option.role = "option"
      option.className = "dropdown-menu-item dropdown-menu-button"
      option.setAttribute("aria-selected", "false")
      option.dataset.railsuiDropdownMenuTarget = "row"
      option.dataset.id = option.id
      option.dataset.value = optionData
      option.dataset.label = optionData
      option.dataset.action = "click->railsui-dropdown-menu#select"
      option.textContent = optionData
      menuBody.appendChild(option)
    })

    this.setDropdownValue(id, "")
  }

  syncDropdownSummary(field){
    const shell = field.closest("[data-controller~='railsui-dropdown-menu']")
    const summary = shell?.querySelector("[data-railsui-dropdown-menu-target~='summary']")
    const trigger = shell?.querySelector("[data-railsui-dropdown-menu-target~='trigger']")
    const rows = Array.from(shell?.querySelectorAll("[data-railsui-dropdown-menu-target~='row']") || [])
    const selectedRow = rows.find((row) => row.dataset.value === field.value)

    rows.forEach((row) => {
      const selected = row === selectedRow
      row.classList.toggle("is-selected", selected)
      row.setAttribute("aria-selected", selected.toString())
    })

    if (summary) {
      summary.textContent = selectedRow?.dataset.label || shell?.dataset.railsuiDropdownMenuPlaceholderValue || "Select"
      summary.classList.toggle("is-selected", Boolean(selectedRow))
    }

    trigger?.classList.toggle("has-selection", Boolean(selectedRow))
  }

  markRequired(id){
    const field = document.getElementById(id)
    if (!field) {
      return
    }

    field.setAttribute("required", "required")
    const dropdownField = field.closest(".dropdown-field")
    dropdownField?.querySelector("[data-railsui-dropdown-menu-target~='trigger']")?.setAttribute("aria-required", "true")
    this.ensureRequiredIndicator(dropdownField?.querySelector(".dropdown-field-label-row"))
  }

  clearRequired(id){
    const field = document.getElementById(id)
    if (!field) {
      return
    }

    field.removeAttribute("required")
    const dropdownField = field.closest(".dropdown-field")
    dropdownField?.querySelector("[data-railsui-dropdown-menu-target~='trigger']")?.removeAttribute("aria-required")
    this.removeRequiredIndicator(dropdownField?.querySelector(".dropdown-field-label-row"))
  }

  ensureRequiredIndicator(labelRow) {
    if (!labelRow || labelRow.querySelector(".dropdown-field-required")) {
      return
    }

    const asterisk = document.createElement("span")
    asterisk.className = "dropdown-field-required"
    asterisk.setAttribute("aria-hidden", "true")
    asterisk.textContent = "*"

    const srOnly = document.createElement("span")
    srOnly.className = "sr-only"
    srOnly.textContent = "Required"

    const label = labelRow.querySelector(".dropdown-field-label")
    if (label) {
      label.after(asterisk, srOnly)
    } else {
      labelRow.append(asterisk, srOnly)
    }
  }

  removeRequiredIndicator(labelRow) {
    const asterisk = labelRow?.querySelector(".dropdown-field-required")
    if (!asterisk) {
      return
    }

    const srOnly = asterisk.nextElementSibling
    asterisk.remove()
    if (srOnly?.classList.contains("sr-only") && srOnly.textContent === "Required") {
      srOnly.remove()
    }
  }

  validateRequiredDropdowns(event){
    const missingDropdown = Array.from(this.element.querySelectorAll(".dropdown-field input[type='hidden'][required]")).find((field) => {
      return this.isVisible(field.closest(".dropdown-field")) && !field.value
    })

    if (!missingDropdown) {
      return true
    }

    const label = missingDropdown.closest(".dropdown-field")?.querySelector(".dropdown-field-label")?.textContent?.trim() || "required dropdown"
    alert(`Please select ${label}.`)
    event.preventDefault()
    missingDropdown.closest(".dropdown-field")?.querySelector("[data-railsui-dropdown-menu-target~='trigger']")?.focus()
    return false
  }

  isVisible(element){
    return Boolean(element && element.offsetParent !== null)
  }

  updateCheckboxState(event){
    if((event.target.scrollTop + event.target.clientHeight) > (event.target.scrollHeight - 500)) {
      const checkbox = document.getElementById("user-agreement-checkbox")
      checkbox.disabled=false
      document.getElementById("user-agreement-label")?.classList.remove("grayed-out-text")
      checkbox.closest(".form-checkbox")?.classList.remove("grayed-out-text")
    }
  }

  validateCheckboxes(){
    let checkboxArray1 = document.getElementById("work-with-learners-in").querySelectorAll('input[type=checkbox]')
    let checkboxCheck1 = Array.from(checkboxArray1).find((element) => element.checked === true);
    if (!checkboxCheck1) {
      alert("Please answer the question `I WORK WITH LEARNERS IN`")
      event.preventDefault();
    }

    if(document.getElementById("work-with-students-in").style.display != 'none') {
      let checkboxArray2 = document.getElementById("work-with-students-in").querySelectorAll('input[type=checkbox]')
      let checkboxCheck2 = Array.from(checkboxArray2).find((element) => element.checked === true);
      if (!checkboxCheck2) {
        alert("Please answer the question `I WORK WITH LEARNERS IN THE FOLLOWING DISCIPLINES`")
        event.preventDefault();
      }
    }

    let checkboxArray3 = document.getElementById("primary-clinical-discipline").querySelectorAll('input[type=checkbox]')
    let checkboxCheck3 = Array.from(checkboxArray3).find((element) => element.checked === true);
    if (!checkboxCheck3) {
      alert("Please answer the question `MY PRIMARY CLINICAL DISCIPLINE IS`")
      event.preventDefault();
    }
  }

  validateDateFieldsPopupForm(event){
    let startDate = document.getElementById("course-reminder-start-date").value;
    let endDate = document.getElementById("course-reminder-end-date").value;
    if (startDate && endDate) {
      let start = new Date(startDate);
      let end = new Date(endDate);
    
      if (end <= start) {
        alert("Please select an end date that is after the start date.");
        event.preventDefault();
        return;
      }
    }
  }
}
